export default __webpack_public_path__ + "static/media/daily-look.b96b5b5d.png";